import React, { Component } from "react";
import Greeting from "../../components/greetings/greeting";
import Header from "../../components/header/Header";
import About from "../../components/about/about";
import WhatIdo from "../../components/whatIDo/whatIdo";
import Footer from "../../components/footer/footer"
import Education from "../../components/education/education";
import ContactComponent from "../../components/contact/contact";
import Project from "../../components/projects/project";
import ExperienceComponent from "../../components/experience/experienceComponent";
// import Skills from "../skills/skills";
import SkillsComponent from "../../components/skills/skillsComponent";
import OpenSourceComponent from "../../components/openSource/openSource.tsx";

class Home extends Component {

  render() {

    return (
      <div>
      <Header />
      <Greeting/>
      <About/>
      <WhatIdo/>
      <ExperienceComponent/>
      <Project/>
      <OpenSourceComponent/>
      <SkillsComponent/>
      <Education/>
      <ContactComponent/>
      <Footer/>
      </div>
    );
  }
}


export default Home;
